module.exports = __webpack_public_path__ + "static/media/14_l_Layer5_1.2_5.37.aef63808.png";